import {Component, OnInit, ViewChild} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {FrameworkHttpService} from '../framework/http/service';
import {QARService, ReportParticipationEntity} from '../services/qar.service';
import {AppUser, AppUserData} from '../framework/AppUser';
import {UITableComponent} from '../framework/ui/table';


@Component({
	selector: 'app-page-report-browser',
	templateUrl: './report-browser.html',
	providers: [QARService, AppUser]
})
export class ReportBrowserPageComponent implements OnInit {

	@ViewChild('tableReportRows', {static: false}) tableReportRows: UITableComponent;

	constructor(public api: QARService, public user: AppUser) {
	}

	ngOnInit() {
		this.reports_init();
		
	}

	public reports_init() {
		this.report.isApprover = this.user.hasGroup('APPROVERS');
		this.report.isSuperApprover = this.user.hasGroup('SUPER_APPROVERS');
		this.reports.loading = true;
		
		this.api.retrieveQARReportsForReportBrowser().then(r => {
			this.reports.loading = false;
			this.reports.chunker = new Chunker(r);
		});
	}

	public reports = {
		loading: false,
		selected: null,
		selectedId: null,
		chunker: (new Chunker([])),
		chunkedData: [],
		tableHeaders: [
			{id: 'name', label: 'Report', filterable: true},
			{id: 'year', label: 'Year', filterable: true},
			{id: 'statusId', label: 'Status', filterable: true},
			{id: 'opened', label: 'Date Opened'},
			{id: 'closed', label: 'Date Closed'},
		],
	};

	public report = {
		loading: false,
		chunker: (new Chunker([])),
		chunkedData: [],
		statusDescriptions: {
			pending: 'Pending',
			completed: 'Completed',
			counter_signed: 'Countersigned'
		},
		isApprover: false,
		isSuperApprover: false,
		isLogin: AppUser.data.login,
		tableHeaders: [
			{
				id: 'ApproverFirstName',
				label: 'Approver First Name',
				filterable: true,
				idFunction: this.report_idFunctionApproverFirstName,
				sortable: true
			},
			{
				id: 'ApproverLastName',
				label: 'Approver Last Name',
				filterable: true,
				idFunction: this.report_idFunctionApproverLastName,
				sortable: true
			},
			{
				id: 'StatusId', label: 'Status', filterable: true, type: 'dropdown', options: {
					choices: {
						pending: 'Pending',
						completed: 'Completed',
						counter_signed: 'Countersigned'
					},
					emptyChoiceText: '(All)'
				}, style: 'width:125px', sortable: true
			},
			{id: 'CompletedDate', label: 'Date Completed', filterable: true, type: 'date', style: 'width:150px', sortable: true},
			{id: 'CounterSignedDate', label: 'Date Countersigned', filterable: true, type: 'date', style: 'width:150px', sortable: true},
			{id: 'OpenButton', label: 'Action', filterable: false, sortable: false},
		],
		tableOptions: {
			downloadAsExcel: false,
			downloadAsExcelRowFormatter: this.downloadAsExcelRowFormatter,
			downloadAsExcelHeaders: this.downloadAsExcelHeaders,
			refreshButton: true,
			onRefreshContext: this,
			onRefreshFunction: () => {
				this.onReportRowClick(this.reports.selected);
			}
		}
	};
	public systemsFilter = {
		open: false,
		allRows: [] as ReportParticipationEntity[],
		availableSystems: [] as string[],
		draftSelected: {} as { [systemName: string]: boolean },
		appliedSelected: {} as { [systemName: string]: boolean }
	};

	report_idFunctionApproverFirstName(d) {
		return d.SORUserOverridenApproverId ? d.SORUserOverridenApprover?.FirstName : d.SORUserApprover?.FirstName;
	}

	report_idFunctionApproverLastName(d) {
		return d.SORUserOverridenApproverId ? d.SORUserOverridenApprover?.LastName : d.SORUserApprover?.LastName;
	}

	// only approver who are assigned to the report OR super approver
	report_canSeeOpenReportButton(reportParticipationEntity: ReportParticipationEntity) {
		// console.log('can see', reportParticipationEntity);
		if (this.report.isApprover && !this.report.isSuperApprover) {
			const userLogin = reportParticipationEntity.SORUserOverridenApproverId === null ? reportParticipationEntity.SORUserApprover.Login : reportParticipationEntity.SORUserOverridenApprover.Login;
			return userLogin === this.user.getLogin();
		}
		return this.report.isSuperApprover;
	}
	public delete_Report(id) {
		console.log('delete_Report', id);
		this.api.deleteReport(id).then(r => {
			window.location.reload();
	    this.reports_init();
		});
	}

	report_canSeeDataSet(reportParticipationEntity: ReportParticipationEntity) {
		// console.log('can see', reportParticipationEntity);
		if (this.report.isApprover && !this.report.isSuperApprover) {
			const userLogin = reportParticipationEntity.SORUserOverridenApproverId === null ? reportParticipationEntity.SORUserApprover.Login : reportParticipationEntity.SORUserOverridenApprover.Login;
			return userLogin === this.user.getLogin();
		}
		return true;
	}

	onReportRowClick(report) {
		this.reports.selected = report;
		this.reports.selectedId = report.Id;
		this.report.loading = true;
		this.systemsFilter.open = false;
		this.systemsFilter.allRows = [];
		this.systemsFilter.availableSystems = [];
		this.systemsFilter.draftSelected = {};
		this.systemsFilter.appliedSelected = {};
		this.api.retrieveQARReportsBrowserRows(report.Id).then(r => {
			this.report.loading = false;

			const visible = [];
			for (const row of r) {
				console.log('row', row);
				if (this.report_canSeeDataSet(row)) {
					visible.push(row);
				}
			}
			this.systemsFilter.allRows = visible;
			const systemSet: { [s: string]: boolean } = {};
			for (const row of visible) {
				const sys = (row as any).Systems || [];
				for (const s of sys) {
					if (s) {
						systemSet[s] = true;
					}
				}
			}
			this.systemsFilter.availableSystems = Object.keys(systemSet).sort();
			this.systemsFilter.draftSelected = {};
			this.systemsFilter.appliedSelected = {};
			for (const s of this.systemsFilter.availableSystems) {
				this.systemsFilter.draftSelected[s] = true;
				this.systemsFilter.appliedSelected[s] = true;
			}
			this.report.chunker = new Chunker(visible);
			if (this.tableReportRows) {
				this.tableReportRows.removeFilters();
			}
			/*
			default filter
			setTimeout(() => {
				if (this.report.isSuperApprover || this.report.isApprover) {
					this.report.tableHeaders[2]['filterValue'] = this.report.isSuperApprover ? 'completed' : 'pending';
				}
			}, 100);*/
		}, e => {
			alert('sorry, failed to load the datasets,please try again');
		});

	}
	public onSystemDraftToggle(systemName: string, checked: boolean) {
		this.systemsFilter.draftSelected[systemName] = checked;
	}
	public isAnySystemDraftSelected(): boolean {
		for (const s of this.systemsFilter.availableSystems) {
			if (this.systemsFilter.draftSelected[s]) {
				return true;
			}
		}
		return false;
	}
	public applySystemsFilter() {
		if (!this.isAnySystemDraftSelected()) {
			// Safety net - OK button is already disabled in this case per AC
			return;
		}
		// Commit draft -> applied
		this.systemsFilter.appliedSelected = {};
		for (const s of this.systemsFilter.availableSystems) {
			this.systemsFilter.appliedSelected[s] = !!this.systemsFilter.draftSelected[s];
		}
		// Filter rows: keep row if any of its systems is in the applied set
		const filtered = [];
		for (const row of this.systemsFilter.allRows) {
			const rowSystems = (row as any).Systems || [];
			let match = false;
			for (const s of rowSystems) {
				if (this.systemsFilter.appliedSelected[s]) {
					match = true;
					break;
				}
			}
			if (match) {
				filtered.push(row);
			}
		}
		this.report.chunker = new Chunker(filtered);
		if (this.tableReportRows) {
			this.tableReportRows.removeFilters();
		}
		this.systemsFilter.open = false;
	}
	public cancelSystemsFilter() {
		// Revert draft to applied state and close
		this.systemsFilter.draftSelected = {};
		for (const s of this.systemsFilter.availableSystems) {
			this.systemsFilter.draftSelected[s] = !!this.systemsFilter.appliedSelected[s];
		}
		this.systemsFilter.open = false;
	}
	downloadAsExcelHeaders() {
		return [
			{id: 'ApproverFirstName', label: 'Approver First Name'},
			{id: 'ApproverLastName', label: 'Approver Last Name'},
			{id: 'StatusId', label: 'Status'},
			{id: 'CompletedDate', label: 'Date Completed'},
			{id: 'CounterSigner', label: 'Date Countersigned'},
		];
	}

	downloadAsExcelRowFormatter(headerId, currentValue, r) {
		console.log('downloadAsExcelRowFormatter', headerId, currentValue, r);
		switch (headerId) {
			case 'ApproverFirstName':
				return r.SORUserrOverridenApproverId ? r.SORUserrOverridenApprover?.FirstName : r.SORUserApprover?.FirstName;
			case 'ApproverLastName':
				return r.SORUserrOverridenApproverId ? r.SORUserrOverridenApprover?.FirstName : r.SORUserApprover?.LastName;
			case 'StatusId':
				return this.report.statusDescriptions[r.StatusId];
			default:
				return r[headerId];
		}
	}
}
